import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import { StyledButton, StyledContainer, StyledImage, StyledStack } from './styles';
import { Link } from 'gatsby';

export default function PromotionCard({ variant = 'promotion', promotion = {} }) {
  const { t } = useTranslation();

  return (
    <StyledContainer variant={variant} bgImageSrc={promotion?.bgImageSrc}>
      {variant === 'checkout' && <StyledImage src={promotion?.bgImageSrc} alt="promotion" />}
      <StyledStack variant={variant}>
        {Boolean(promotion.titleImageSrc) && (
          <img
            src={promotion?.titleImageSrc}
            alt="promotion"
            style={{
              width: '100px',
              height: '38px',
              objectFit: 'contain',
            }}
          />
        )}

        <Typography variant="caption" fontWeight={500} minHeight={80}>
          {promotion?.description}
        </Typography>
        {variant === 'promotion' && promotion.link && (
          <StyledButton LinkComponent={Link} href={promotion.link} size="medium" variant="outlined">
            {t('see_more')}
          </StyledButton>
        )}
      </StyledStack>
    </StyledContainer>
  );
}
